(() => {
  'use strict';

  /*
   * Promociones comerciales ELEVENINE.
   * IMPORTANTE: el precio ACTUAL no se define aquí; siempre lo toma Shopify.
   * Aquí solo viven el precio anterior, bono y condiciones visuales de campaña.
   */
  window.ELEVENINE_SURRON_PROMOS = Object.freeze({
    '22:2025': Object.freeze({
      label: 'BONO EN MODELOS 2025 hasta agotar existencias',
      previousPrice: 87220,
      bonus: 9220,
      conditions: Object.freeze(['Solo pago de contado'])
    }),
    '32:2025': Object.freeze({
      label: 'BONO EN MODELOS 2025 hasta agotar existencias',
      previousPrice: 121919,
      bonus: 21929,
      conditions: Object.freeze(['Solo pago de contado', 'No aplica 12 MSI'])
    })
  });
})();
